export default class CommentTagParser {
    static convertTagsToElements(text) {
        text = text.replaceAll('&nbsp;', '');

        let output = '';

        let lastPos = 0;
        let tagStart = text.indexOf('|TAG:');

        while (tagStart >= 0) {
            output += text.substring(lastPos, tagStart);

            // Get tag end
            let tagEnd = text.indexOf(':TAG|', tagStart);
            if (tagEnd < 0) return text;

            const tag = JSON.parse(text.substring(tagStart + 5, tagEnd));
            output += `<span class="user-tag" contentEditable="false" data-user-id="${tag.id}">${tag.name}</span>`;

            lastPos = tagEnd + 5;
            tagStart = text.indexOf('|TAG:', lastPos);
        }

        output += text.substring(lastPos);
        return output;
    }

    static stripTags(text) {
        text = text.replaceAll('&nbsp;', '');

        let output = '';

        let lastPos = 0;
        let tagStart = text.indexOf('|TAG:');

        while (tagStart >= 0) {
            output += text.substring(lastPos, tagStart);

            // Get tag end
            let tagEnd = text.indexOf(':TAG|', tagStart);
            if (tagEnd < 0) return text;

            const tag = JSON.parse(text.substring(tagStart + 5, tagEnd));
            output += `${tag.name}`;

            lastPos = tagEnd + 5;
            tagStart = text.indexOf('|TAG:', lastPos);
        }

        output += text.substring(lastPos);
        return output;
    }

    static convertElementsToTags(text) {
        text = text.replaceAll('&nbsp;', '');
        text = text.replaceAll('<br>', "\n");

        let output = '';

        let lastPos = 0;
        let tagStart = text.indexOf('<span class="user-tag"');

        while (tagStart >= 0) {
            // Make sure there's a space between tags
            if (lastPos > 0 && text.substring(lastPos, lastPos + 1) !== ' ') {
                output += ' ';
            }

            output += text.substring(lastPos, tagStart);

            // Get tag end
            let tagEnd = text.indexOf('</span>', tagStart);
            if (tagEnd < 0) return text;

            let openingTagEnd = text.indexOf('>', tagStart);
            if (openingTagEnd < 0) return text;

            const name = text.substring(openingTagEnd + 1, tagEnd);

            // Strip out empty tags
            if (name.trim().length > 1) {
                // Get user ID
                let userIDStart = text.indexOf(' data-user-id="', tagStart);
                if (userIDStart < 0) return text;

                let userIDEnd = text.indexOf('"', userIDStart + 15);
                if (userIDEnd < 0) return text;

                const userID = text.substring(userIDStart + 15, userIDEnd);

                const obj = {type: 'user', id: userID, name: name};
                const json = JSON.stringify(obj);

                output += '|TAG:' + json + ':TAG|';
            }

            lastPos = tagEnd + 7;
            tagStart = text.indexOf('<span class="user-tag"', lastPos);
        }

        // Make sure there's a space between tags
        if (lastPos > 0 && text.substring(lastPos, lastPos + 1) !== ' ') {
            output += ' ';
        }

        output += text.substring(lastPos);
        return output;
    }
}